import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useAuth } from "@/hooks/useAuth";

export const SuspensionScreen = () => {
  const { signOut } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Card className="max-w-md w-full border-destructive/40">
        <CardContent className="p-8 text-center space-y-4">
          <div className="mx-auto w-14 h-14 rounded-full bg-destructive/10 flex items-center justify-center">
            <ShieldAlert className="h-7 w-7 text-destructive" />
          </div>
          <div className="space-y-2">
            <h1 className="text-xl font-bold">Your account has been suspended</h1>
            <p className="text-sm text-muted-foreground">
              Your Swiftix account is no longer active because of a violation of our community guidelines.
              If you believe this is a mistake, contact{" "}
              <a className="text-primary hover:underline" href="mailto:support@swiftix.app">support@swiftix.app</a>.
            </p>
          </div>
          <Button variant="outline" onClick={() => void signOut()} className="w-full">Sign out</Button>
        </CardContent>
      </Card>
    </div>
  );
};
